module.exports = __webpack_public_path__ + "static/media/espn_feature_story___id_15278522_how-tiger-woods-life-unraveled-years-father-earl-woods-death_plot.3de803b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/espn_feature_story___id_15278522_how-tiger-woods-life-unraveled-years-father-earl-woods-death_plot.png
// module id = 387
// module chunks = 0